<template>
  <div class="flex-grow-1">
    <div class="row w-100 mb-2">
      <div class="col-4">
        <label>Billing</label>
      </div>
      <div class="col-8 pr-0" style="gap: 10px">
        <multiselect
          :value="billingValue"
          :options="billingOptions"
          @remove="($event) => handleRemove($event, 'billing')"
          label="label"
          select-label=""
          deselect-label=""
          :allow-empty="true"
          track-by="tagId"
          :multiple="true"
          @select="($event) => handleSelect($event, 'billing')"
          :style="
            errorFields.indexOf('billing') >= 0 ||
            errorFields.indexOf('billingTagError') >= 0
              ? 'border: 1px solid red; border-radius:5px'
              : ''
          "
        >
        </multiselect>
        <p
          v-if="errorFields.indexOf('billing') >= 0"
          class="text-danger error-text mb-0 mt-1"
        >
          Tidak boleh kosong
        </p>
        <p
          v-if="errorFields.indexOf('billingTagError') >= 0"
          class="text-danger error-text mb-0 mt-1"
        >
          Tag “–” tidak bisa dikombinasikan dengan tag lain. Hilangkan tag "-"
          untuk melakukan kombinasi tag lainnya.
        </p>
        <div class="rounded bg-light mt-2 d-flex p-2 text-grey">
          <i class="bi bi-exclamation-circle" style="font-size: 12px"></i>
          <p
            v-html="billingTooltip"
            class="m-0 ml-2"
            style="font-size: 12px"
          ></p>
        </div>
      </div>
    </div>
    <hr />
    <div class="row w-100">
      <div class="col-4">
        <label>Due Date</label>
      </div>
      <div class="col-8 pr-0">
        <multiselect
          v-model="dueDateValue"
          :options="dueDateOptions"
          label="label"
          select-label=""
          deselect-label=""
          :allow-empty="false"
          track-by="tagId"
          placeholder="-"
          @select="($event) => handleSelect($event, 'dueDate')"
          :style="
            errorFields.indexOf('dueDate') >= 0
              ? 'border: 1px solid red; border-radius:5px'
              : ''
          "
        >
        </multiselect>
        <p
          v-if="errorFields.indexOf('dueDate') >= 0"
          class="text-danger error-text mb-0 mt-1"
        >
          Tidak boleh kosong
        </p>
      </div>
    </div>
    <div
      v-if="dueDateValue && dueDateValue.tagId === 159"
      class="row w-100 align-items-center mt-2"
    >
      <label class="col-4">Custom Due Date</label>
      <div class="col-3 input_number" style="gap: 10px">
        <input
          v-model="customDueDate"
          type="number"
          placeholder="-"
          @change="($event) => handleChangeInput($event, 'customDueDate')"
          class="form-control"
          :style="
            errorFields.indexOf('customDueDate') >= 0
              ? 'border: 1px solid red; border-radius:5px'
              : ''
          "
        />
        <p
          v-if="errorFields.indexOf('customDueDate') >= 0"
          class="text-danger error-text mb-0 mt-1"
        >
          Tidak boleh kosong
        </p>
      </div>
    </div>
    <div class="row w-100 mb-2">
      <div class="col-4"></div>
      <div class="col-8">
        <div class="rounded bg-light mt-2 d-flex p-2 text-grey">
          <i class="bi bi-exclamation-circle" style="font-size: 12px"></i>
          <p
            v-html="dueDateTooltip"
            class="m-0 ml-2"
            style="font-size: 12px"
          ></p>
        </div>
      </div>
    </div>
    <hr />
    <div class="row w-100">
      <div class="col-4">
        <label>Billed Per</label>
      </div>
      <div class="col-8 pr-0 app_input" style="gap: 10px">
        <multiselect
          v-model="billedPerValue"
          :options="billedPerOptions"
          label="label"
          select-label=""
          deselect-label=""
          :allow-empty="false"
          track-by="tagId"
          placeholder="-"
          disabled
          @select="($event) => handleSelect($event, 'billedPer')"
          :style="
            errorFields.indexOf('billedPer') >= 0
              ? 'border: 1px solid red; border-radius:5px'
              : ''
          "
        >
        </multiselect>
        <p
          v-if="errorFields.indexOf('billedPer') >= 0"
          class="text-danger error-text mb-0 mt-1"
        >
          Tidak boleh kosong
        </p>
      </div>
    </div>
    <div
      v-if="billedPerValue && billedPerValue.tagId === 167"
      class="row w-100 align-items-center mt-2"
    >
      <label class="col-4">Upfront</label>
      <div class="row col-8" style="padding-right: 0">
        <div class="col-4">
          <multiselect
            v-model="upfrontValue"
            :options="upfrontOptions"
            label="label"
            select-label=""
            deselect-label=""
            selected-label=""
            placeholder="-"
            @select="($event) => handleSelect($event, 'upfront')"
            :allow-empty="false"
            track-by="tagId"
            :style="
              errorFields.indexOf('upfront') >= 0
                ? 'border: 1px solid red; border-radius:5px'
                : ''
            "
          >
          </multiselect>
        </div>
        <div class="col-8" style="padding: 0">
          <date-picker
            :style="`width: 100%; ${
              errorFields.indexOf('billingDate') >= 0 ||
              errorFields.indexOf('billingDateBackdated') >= 0
                ? 'border: 1px solid red; border-radius:5px'
                : ''
            }`"
            v-model="billingDate"
            type="date"
            :editable="false"
            :disabled-date="disabledDate"
            format="DD-MM-YYYY"
            placeholder="dd-mm-yyyy"
            @change="handleChangeInput($event, 'billingDate')"
          ></date-picker>
        </div>
        <div v-if="errorFields.indexOf('billingDate') >= 0" class="col-12">
          <p class="text-danger error-text mb-0 mt-1">Tidak boleh kosong</p>
        </div>
      </div>
    </div>
    <div
      v-if="upfrontValue && upfrontValue.tagId === 16"
      class="row w-100 align-items-center mt-2"
    >
      <div class="col-4"></div>
      <div class="row col-8" style="padding-right: 0">
        <div class="col-4">
          <input
            value="10%"
            type="text"
            disabled
            class="form-control date_input"
            style="height: 100%"
          />
        </div>
        <div class="col-8" style="padding: 0">
          <date-picker
            :style="`width: 100%; ${
              errorFields.indexOf('billingDate10') >= 0 ||
              errorFields.indexOf('billingDate10Backdated') >= 0
                ? 'border: 1px solid red; border-radius:5px'
                : ''
            }`"
            v-model="billingDate10"
            type="date"
            :editable="false"
            :disabled-date="disabledDate"
            format="DD-MM-YYYY"
            placeholder="dd-mm-yyyy"
            @change="handleChangeInput($event, 'billingDate10')"
          ></date-picker>
        </div>
        <div v-if="errorFields.indexOf('billingDate') >= 0" class="col-12">
          <p class="text-danger error-text mb-0 mt-1">Tidak boleh kosong</p>
        </div>
      </div>
    </div>
    <div class="row mb-2 w-100">
      <div class="col-4"></div>
      <div class="col-8">
        <div class="rounded bg-light mt-2 d-flex p-2 text-grey">
          <i class="bi bi-exclamation-circle" style="font-size: 12px"></i>
          <p
            v-html="billedPerTooltip"
            class="m-0 ml-2"
            style="font-size: 12px"
          ></p>
        </div>
      </div>
    </div>
    <hr />
    <div class="row w-100 mb-2">
      <div class="col-4">
        <label>Billing Calculation </label>
      </div>
      <div class="col-8 pr-0" style="gap: 10px">
        <multiselect
          :value="billingCalculationValue"
          :options="billingCalculationOptions"
          label="label"
          select-label=""
          deselect-label=""
          :allow-empty="false"
          track-by="tagId"
          placeholder="-"
          @select="($event) => handleSelect($event, 'billingCalculation')"
          :disabled="billedPerValue && billedPerValue.tagId === 167"
          :style="
            errorFields.indexOf('billingCalculation') >= 0
              ? 'border: 1px solid red; border-radius:5px'
              : ''
          "
        >
        </multiselect>
        <p
          v-if="errorFields.indexOf('billingCalculation') >= 0"
          class="text-danger error-text mb-0 mt-1"
        >
          Tidak boleh kosong
        </p>
        <div class="rounded bg-light mt-2 d-flex p-2 text-grey">
          <i class="bi bi-exclamation-circle" style="font-size: 12px"></i>
          <p
            v-html="billingCalculationTooltip"
            class="m-0 ml-2"
            style="font-size: 12px"
          ></p>
        </div>
      </div>
    </div>
    <hr />
    <div class="row w-100">
      <div class="col-4">
        <label>Recurring Billing Day</label>
      </div>
      <div class="col-8 pr-0" style="gap: 10px">
        <multiselect
          v-model="recurringBillingDayValue"
          :options="recurringBillingDayOptions"
          label="label"
          select-label=""
          deselect-label=""
          :allow-empty="false"
          track-by="tagId"
          placeholder="-"
          :disabled="billedPerValue && billedPerValue.tagId === 167"
          @select="($event) => handleSelect($event, 'recurringBillingDay')"
          :style="
            errorFields.indexOf('recurringBillingDay') >= 0
              ? 'border: 1px solid red; border-radius:5px'
              : ''
          "
        >
        </multiselect>
        <p
          v-if="errorFields.indexOf('recurringBillingDay') >= 0"
          class="text-danger error-text mb-0 mt-1"
        >
          Tidak boleh kosong
        </p>
      </div>
    </div>
    <div
      v-if="recurringBillingDayValue && recurringBillingDayValue.tagId === 164"
      class="row w-100 align-items-center"
    >
      <label class="col-4">Custom Recurring Billing Day</label>
      <div class="col-8 row align-items-center input_number">
        <p class="mb-0 col-3">Every</p>
        <input
          v-model="customRecurringBillingDay"
          type="number"
          placeholder="-"
          @change="
            ($event) => handleChangeInput($event, 'customRecurringBillingDay')
          "
          class="form-control col-3"
          :disabled="billedPerValue && billedPerValue.tagId === 167"
          :style="
            errorFields.indexOf('customRecurringBillingDay') >= 0
              ? 'border: 1px solid red; border-radius:5px'
              : ''
          "
        />
        <p class="mb-0 col-6">of the month</p>
        <div
          v-if="errorFields.indexOf('customRecurringBillingDay') >= 0"
          class="col-12"
        >
          <p class="text-danger error-text mb-0 mt-1">Tidak boleh kosong</p>
        </div>
      </div>
    </div>
    <div class="row w-100 mb-2">
      <div class="col-4"></div>
      <div class="col-8">
        <div class="rounded bg-light mt-2 d-flex p-2 text-grey">
          <i class="bi bi-exclamation-circle" style="font-size: 12px"></i>
          <p
            v-html="recurringBillingDayTooltip"
            class="m-0 ml-2"
            style="font-size: 12px"
          ></p>
        </div>
      </div>
    </div>
    <hr />
    <div class="row w-100 mb-2">
      <div class="col-4">
        <label>Billing Start</label>
      </div>
      <div class="col-8">
        <div class="d-flex align-items-center pr-0" style="gap: 10px">
          <multiselect
            :value="billingStartValue"
            :options="billingStartOptions"
            label="label"
            select-label=""
            deselect-label=""
            :allow-empty="false"
            track-by="tagId"
            placeholder="-"
            @select="($event) => handleSelect($event, 'billingStart')"
            :disabled="billedPerValue && billedPerValue.tagId === 167"
            :style="
              errorFields.indexOf('billingStart') >= 0
                ? 'border: 1px solid red; border-radius:5px'
                : ''
            "
          >
          </multiselect>
        </div>
        <p
          v-if="errorFields.indexOf('billingStart') >= 0"
          class="text-danger error-text mb-0 mt-1"
        >
          Tidak boleh kosong
        </p>
        <div class="rounded bg-light mt-2 d-flex p-2 text-grey">
          <i class="bi bi-exclamation-circle" style="font-size: 12px"></i>
          <p
            v-html="billingStartTooltip"
            class="m-0 ml-2"
            style="font-size: 12px"
          ></p>
        </div>
      </div>
    </div>
    <hr />
    <div class="row w-100 mb-2">
      <label class="col-4">Invoice Type</label>
      <div class="col-8 pr-0" style="gap: 10px">
        <multiselect
          v-model="invoiceTypeValue"
          :options="invoiceTypeOptions"
          label="label"
          select-label=""
          deselect-label=""
          :allow-empty="false"
          track-by="tagId"
          placeholder="-"
          @select="($event) => handleSelect($event, 'invoiceType')"
          :style="
            errorFields.indexOf('invoiceType') >= 0
              ? 'border: 1px solid red; border-radius:5px'
              : ''
          "
        >
        </multiselect>
        <p
          v-if="errorFields.indexOf('invoiceType') >= 0"
          class="text-danger error-text mb-0 mt-1"
        >
          Tidak boleh kosong
        </p>
      </div>
    </div>
    <hr />
    <div class="row w-100 align-items-center mb-2">
      <label class="col-4">Additional Request/Doc</label>
      <div class="col-8 pr-0" style="gap: 10px">
        <multiselect
          v-model="additionalReqOrDocValue"
          :options="additionalReqOrDocOptions"
          label="label"
          select-label=""
          deselect-label=""
          :allow-empty="false"
          track-by="tagId"
          placeholder="-"
          @select="($event) => handleSelect($event, 'additionalReqOrDoc')"
          :style="
            errorFields.indexOf('additionalReqOrDoc') >= 0
              ? 'border: 1px solid red; border-radius:5px'
              : ''
          "
        >
        </multiselect>
        <p
          v-if="errorFields.indexOf('additionalReqOrDoc') >= 0"
          class="text-danger error-text mb-0 mt-1"
        >
          Tidak boleh kosong
        </p>
      </div>
    </div>
    <hr />
    <div class="row w-100 align-items-center mb-2">
      <label class="col-4">Deposit</label>
      <div class="col-8 pr-0" style="gap: 10px">
        <multiselect
          v-model="depositValue"
          :options="depositOptions"
          label="label"
          select-label=""
          deselect-label=""
          :allow-empty="false"
          track-by="tagId"
          placeholder="-"
          @select="($event) => handleSelect($event, 'deposit')"
          :style="
            errorFields.indexOf('deposit') >= 0
              ? 'border: 1px solid red; border-radius:5px'
              : ''
          "
        >
        </multiselect>
        <p
          v-if="errorFields.indexOf('deposit') >= 0"
          class="text-danger error-text mb-0 mt-1"
        >
          Tidak boleh kosong
        </p>
      </div>
    </div>

    <div v-if="isInputFieldEmpty">
      <p class="mb-0" style="color: red; font-size: 12px">
        * Semua field wajib diisi
      </p>
    </div>
    <div v-if="isInputFieldError">
      <p class="mt-0" style="color: red; font-size: 12px">
        * Terdapat input field yang tidak sesuai
      </p>
    </div>
  </div>
</template>

<script>
import swal from "sweetalert";
import Multiselect from "vue-multiselect";
import DatePicker from "vue2-datepicker";
import moment from "moment";
import Swal2 from "sweetalert2";

export default {
  name: "OrderTagForm",
  components: {
    Multiselect,
    DatePicker,
  },
  data() {
    return {
      billingValue: null,
      billingOptions: [],
      recurringBillingDayOptions: [],
      recurringBillingDayValue: null,
      dueDateOptions: [],
      dueDateValue: null,
      billingStartOptions: [],
      billingStartValue: null,
      upfrontOptions: [],
      upfrontValue: null,
      billingCalculationOptions: [],
      billingCalculationValue: null,
      invoiceTypeOptions: [],
      invoiceTypeValue: null,
      billedPerOptions: [],
      billedPerValue: null,
      additionalReqOrDocOptions: [],
      additionalReqOrDocValue: null,
      depositOptions: [],
      depositValue: null,
      billingDate: null,
      billingDate10: null,
      customDueDate: null,
      customRecurringBillingDay: null,
      salesForm: [],
      errorFields: [],
      tagFormData: null,
      tagsAttributes: [
        "additionalReqOrDoc",
        "billedPer",
        "billingCalculation",
        "billingStart",
        "billing",
        "deposit",
        "dueDate",
        "invoiceType",
        "recurringBillingDay",
        "upfront",
      ],
      billingTooltip: "",
      dueDateTooltip: "",
      billingCalculationTooltip: "",
      billedPerTooltip: "",
      recurringBillingDayTooltip: "",
      billingStartTooltip: "",
      hasActiveInvoice: false,
      isTagExist: false,

      // tags
      tagAfterUsage: 204,
      tagBillingCalcStandard: 160,

      previewPaymentData: [],
    };
  },
  computed: {
    isInputFieldEmpty() {
      if (this.errorFields.length > 0) {
        const emptiedFields = this.errorFields.filter((el) => {
          return (
            el !== "billingDateBackdated" &&
            el !== "billingDate10Backdated" &&
            el !== "billingTagError"
          );
        });
        if (emptiedFields.length > 0) return true;
      }
      return false;
    },
    isInputFieldError() {
      if (this.errorFields.length > 0) {
        const errorFields = this.errorFields.filter((el) => {
          return (
            el === "billingDateBackdated" ||
            el === "billingDate10Backdated" ||
            el === "billingTagError"
          );
        });
        if (errorFields.length > 0) return true;
      }
      return false;
    },
  },
  methods: {
    disabledDate(date) {
      const todayDate = new Date().setHours(0, 0, 0, 0);
      return date < todayDate;
    },
    handleChangeInput(value, type) {
      if (this.errorFields.length > 0) {
        this.errorFields = this.errorFields.filter((el) => el != type);
      }
      if (
        type === "billingDate" &&
        value &&
        !moment(value).isBefore(moment(), "day")
      ) {
        this.errorFields = this.errorFields.filter(
          (el) => el != "billingDateBackdated"
        );
      }
      if (
        type === "billingDate10" &&
        value &&
        !moment(value).isBefore(moment(), "day")
      ) {
        this.errorFields = this.errorFields.filter(
          (el) => el != "billingDate10Backdated"
        );
      }
    },
    handleRemove(value, type) {
      this[type + "Value"] = this[type + "Value"].filter((el) => {
        return el.tagId !== value.tagId;
      });
      if (type === "billing" && this.billingValue) {
        if (
          this.billingValue.length > 1 &&
          this.billingValue.findIndex((el) => el.tagId === 152) < 0
        ) {
          this.errorFields = this.errorFields.filter(
            (el) => el != "billingTagError"
          );
        }
        if (this.billingValue.length === 1) {
          this.errorFields = this.errorFields.filter(
            (el) => el != "billingTagError"
          );
        }
      }
    },
    handleSelect(value, type) {
      /**
       * Validasi kombinasi tag "After Usage" dengan tag "Standard" 
       * pada field "Billing Start" dan "Billing Calculation". 
       * 
        - Jika user memilih tag "After Usage" pada field "Billing Start", 
          maka tag "Standard" pada field "Billing Calculation" 
          tidak bisa dipilih, dan sebaliknya.
       */
      if (type === "billingStart" && value.tagId === this.tagAfterUsage) {
        if (this.billingCalculationValue.tagId == this.tagBillingCalcStandard) {
          return swal(
            "Maaf",
            'Tag "After Usage" tidak bisa dikombinasikan dengan tag "Standard". Hilangkan tag "Standard" untuk melakukan kombinasi tag "After Usage".',
            "error",
            {
              button: "Ok",
            }
          );
        }
      }

      if (type === "billingCalculation" && this.billingStartValue) {
        if (
          this.billingStartValue.tagId == this.tagAfterUsage &&
          value.tagId === this.tagBillingCalcStandard
        ) {
          return swal(
            "Maaf",
            'Tag "After Usage" tidak bisa dikombinasikan dengan tag "Standard". Hilangkan tag "Standard" untuk melakukan kombinasi tag "After Usage".',
            "error",
            {
              button: "Ok",
            }
          );
        }
        if (this.orderStatus === 13 && this.hasActiveInvoice) {
          return swal(
            "Maaf",
            "Tidak bisa mengganti Tag Billing Calculation ketika invoice sudah ditagihkan",
            "error",
            {
              button: "Ok",
            }
          );
        }
      }
      // Batas akhir validasi kombinasi tag "After Usage" dengan tag "Standard"

      if (type === "billing" && this.billingValue) {
        const dashedIndexValue = this.billingValue.findIndex(
          (el) => el.tagId === 152
        );
        if (dashedIndexValue >= 0 && value.tagId !== 152) {
          return swal(
            "Maaf",
            'Tag "-" tidak bisa dikombinasikan dengan tag lain. Hilangkan tag "-" untuk melakukan kombinasi tag lainnya',
            "error",
            {
              button: "Ok",
            }
          );
        }
        const dataOtherThanDash = this.billingValue.filter(
          (el) => el.tagId !== 152
        );
        if (value.tagId === 152 && dataOtherThanDash.length > 0) {
          return swal(
            "Maaf",
            'Tag "-" tidak bisa dikombinasikan dengan tag lain. Hilangkan tag "-" untuk melakukan kombinasi tag lainnya.',
            "error",
            {
              button: "Ok",
            }
          );
        }
        this.billingValue.push(value);
        this.errorFields = this.errorFields.filter(
          (el) => el != "billingTagError"
        );
      }
      if (this.errorFields.length > 0) {
        this.errorFields = this.errorFields.filter((el) => el != type);
      }
      switch (type) {
        case "billedPer":
          if (value.tagId !== 167) {
            this.upfrontValue = null;
            this.billingDate = null;
            this.billingDate10 = null;
          } else {
            this.customRecurringBillingDay = null;
            this.billingStartValue = null;
            this.recurringBillingDayValue = null;
            this.billingCalculationValue = null;
            if (this.errorFields.length > 0) {
              this.errorFields = this.errorFields.filter(
                (el) =>
                  el != "billingStart" &&
                  el != "billingCalculation" &&
                  el != "recurringBillingDay"
              );
            }
          }
          break;
        case "dueDate":
          this.customDueDate = null;
          break;
        case "recurringBillingDay":
          this.customRecurringBillingDay = null;
          break;
        case "billingStart":
          this.billingStartValue = value;
          break;
        case "billingCalculation":
          this.billingCalculationValue = value;
          break;

        default:
          break;
      }
    },
    async submitOrderTag() {
      this.validateForm();
      if (this.errorFields.length <= 0) {
        const sentData = {};
        const tags = [];
        this.tagsAttributes.forEach((el) => {
          const value = this[`${el}Value`];
          if (el === "billing" && value) {
            value.forEach((el) => {
              tags.push({
                tagId: el.tagId,
                label: el.label,
                value: el.value,
              });
            });
          } else if (value) {
            tags.push({
              tagId: value.tagId,
              label: value.label,
              value: value.value,
            });
          }
        });
        this.salesForm.forEach((el) => {
          if (el.selected) {
            el.selected.forEach((item) => {
              tags.push({
                label: item.label,
                tagId: item.tagId,
                value: item.value,
              });
            });
          }
        });
        sentData.tag = tags;
        if (this.customDueDate) {
          sentData.customDueDate = parseInt(this.customDueDate);
        }
        if (this.customRecurringBillingDay) {
          sentData.customRecurringBillingDay = parseInt(
            this.customRecurringBillingDay
          );
        }
        if (this.billingDate) {
          sentData[
            `billingDate${this.upfrontValue.tagId === 7 ? "100" : "90"}`
          ] = moment(this.billingDate).format("YYYY-MM-DD");
        }
        if (this.billingDate10) {
          sentData.billingDate10 = moment(this.billingDate10).format(
            "YYYY-MM-DD"
          );
        }
        sentData.billingCalculation = this.billingCalculationValue.label;
        sentData.billingStart = this.billingStartValue.label;
        sentData.recurringBillingDay = this.recurringBillingDayValue.label;
        return sentData;
      }
      return null;
    },
    validateForm() {
      const errorFields = [];

      this.salesForm.forEach((el) => {
        if (!el.selected) {
          errorFields.push(el.name);
        }
      });

      if (!this.billingValue || this.billingValue.length === 0) {
        errorFields.push("billing");
      }
      if (this.billingValue && this.billingValue.length > 0) {
        const hasDash = this.billingValue.findIndex((el) => el.tagId === 152);
        if (hasDash >= 0 && this.billingValue.length > 1) {
          errorFields.push("billingTagError");
        }
      }
      if (!this.dueDateValue) {
        errorFields.push("dueDate");
      } else {
        if (this.dueDateValue.tagId === 159 && !this.customDueDate) {
          errorFields.push("customDueDate");
        }
      }
      if (!this.billedPerValue) {
        errorFields.push("billedPer");
      }
      if (this.billedPerValue && this.billedPerValue.tagId === 167) {
        if (!this.upfrontValue) {
          errorFields.push("upfront");
        }
        if (!this.billingDate) {
          errorFields.push("billingDate");
        } else {
          // Check whether the billingDate is before the current date
          if (moment(this.billingDate).isBefore(moment(), "day")) {
            errorFields.push("billingDateBackdated");
          }
        }
        if (this.upfrontValue && this.upfrontValue.tagId === 16) {
          if (!this.billingDate10) {
            errorFields.push("billingDate10");
          } else {
            // Check whether the billingDate10 is before the current date
            if (moment(this.billingDate10).isBefore(moment(), "day")) {
              errorFields.push("billingDate10Backdated");
            }
          }
        }
      }
      if (!this.billedPerValue || this.billedPerValue.tagId !== 167) {
        if (!this.recurringBillingDayValue) {
          errorFields.push("recurringBillingDay");
        } else {
          if (
            this.recurringBillingDayValue.tagId === 164 &&
            !this.customRecurringBillingDay
          ) {
            errorFields.push("customRecurringBillingDay");
          }
        }
        if (!this.billingStartValue) {
          errorFields.push("billingStart");
        }
        if (!this.billingCalculationValue) {
          errorFields.push("billingCalculation");
        }
      }
      if (!this.depositValue) {
        errorFields.push("deposit");
      }
      if (!this.invoiceTypeValue) {
        errorFields.push("invoiceType");
      }
      if (!this.additionalReqOrDocValue) {
        errorFields.push("additionalReqOrDoc");
      }
      this.errorFields = errorFields;
    },
    parseOptionValue(option, currentTags, key) {
      option.forEach((item) => {
        if (currentTags.findIndex((val) => val === item.tagId) >= 0) {
          this[key] = item;
        }
      });
    },
    handleMapOrderTagData() {
      const tagsData = [];
      if (this.tagFormData) {
        this.tagFormData.forEach((item) => {
          if (item.child && item.child.length > 0) {
            item.child.forEach((el) => {
              switch (el.idChild) {
                case 2:
                  this.billingOptions = el.value;
                  const selectedData = el.value.reduce((curr, val) => {
                    if (tagsData.findIndex((el) => el === val.tagId) >= 0)
                      return [...curr, val];
                    return curr;
                  }, []);
                  this.billingValue = selectedData;
                  this.billingTooltip = el.tooltip;
                  break;
                case 17:
                  this.recurringBillingDayOptions = el.value;
                  this.parseOptionValue(
                    el.value,
                    tagsData,
                    "recurringBillingDayValue"
                  );
                  this.recurringBillingDayTooltip = el.tooltip;
                  break;
                case 9:
                  this.dueDateOptions = el.value;
                  this.parseOptionValue(el.value, tagsData, "dueDateValue");
                  this.dueDateTooltip = el.tooltip;
                  break;
                case 18:
                  this.billingStartOptions = el.value;
                  this.parseOptionValue(
                    el.value,
                    tagsData,
                    "billingStartValue"
                  );
                  this.billingStartTooltip = el.tooltip;
                  break;
                case 15:
                  this.billingCalculationOptions = el.value;
                  this.parseOptionValue(
                    el.value,
                    tagsData,
                    "billingCalculationValue"
                  );
                  this.billingCalculationTooltip = el.tooltip;
                  break;
                case 10:
                  this.invoiceTypeOptions = el.value;
                  this.parseOptionValue(el.value, tagsData, "invoiceTypeValue");
                  break;
                case 16:
                  this.billedPerOptions = el.value;
                  this.parseOptionValue(el.value, tagsData, "billedPerValue");
                  const upfrontOption = el.value.find((el) => el.tagId === 167);
                  this.upfrontOptions = upfrontOption.child;
                  this.parseOptionValue(
                    upfrontOption.child,
                    tagsData,
                    "upfrontValue"
                  );
                  this.billedPerTooltip = el.tooltip;
                  break;
                case 11:
                  this.additionalReqOrDocOptions = el.value;
                  this.parseOptionValue(
                    el.value,
                    tagsData,
                    "additionalReqOrDocValue"
                  );
                  break;
                case 12:
                  this.depositOptions = el.value;
                  this.parseOptionValue(el.value, tagsData, "depositValue");
                  break;
                default:
                  break;
              }
            });
          }
        });
      }
    },
    getTagForm() {
      this.$http
        .get(process.env.GET_TAG_FORM, {
          headers: { "Asani-Token": localStorage.getItem("jwt") },
        })
        .then((response) => {
          if (response.data.status === 200 && response.data.data.length > 0) {
            this.tagFormData = response.data.data;
            this.handleMapOrderTagData();
          }
        })
        .catch((error) => {
          swal("Sorry", error.response.data.message, "error", {
            button: "Ok",
          }).then((v) => {
            if (error.response.data.status == 401) {
              this.handleLogout();
            }
          });
        });
    },
  },
  watch: {
    billingValue(newVal) {
      if (newVal.length > 0) {
        const dashedIndexValue = newVal.findIndex((el) => el.tagId === 152);
        if (dashedIndexValue >= 0) {
          this.billingOptions = this.billingOptions.map((el) => ({
            ...el,
            $isDisabled: el.tagId === 152 ? false : true,
          }));
        }
        if (dashedIndexValue < 0) {
          this.billingOptions = this.billingOptions.map((el) => ({
            ...el,
            $isDisabled: el.tagId === 152 ? true : false,
          }));
        }
      } else {
        this.billingOptions = this.billingOptions.map((el) => ({
          ...el,
          $isDisabled: false,
        }));
      }
    },
    billedPerOptions(newVal) {
      if (newVal.length > 0) {
        const monthlyIndexValue = newVal.findIndex((el) => el.tagId === 5);
        if (monthlyIndexValue >= 0) {
          this.billedPerValue = newVal[monthlyIndexValue];
        }
      }
    },
  },
  mounted() {
    this.getTagForm();
  },
  created() {},
};
$(document).ready(function () {
  var self = this;
  $('[data-toggle="tooltip"]').tooltip();
});
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@import url("https://cdn.jsdelivr.net/npm/bootstrap-icons@1.11.3/font/bootstrap-icons.min.css");
@import url("https://fonts.googleapis.com/css2?family=Inter:ital,opsz,wght@0,14..32,100..900;1,14..32,100..900&display=swap");

.btn-primary {
  background: #2678e8;
  font-size: 14px;
}

.btn-white {
  background: #ffffff;
  font-size: 14px;
  color: #2e3646;
  border: 1px solid #d1d9e2;
  font-weight: 600;
}

.btn {
  border-radius: 8px;
}

.disabled_option {
  background-color: #5d6575;
  cursor: not-allowed;
}

.inter-font {
  font-family: "Inter", serif;
  font-optical-sizing: auto;
  font-weight: 400;
  font-style: normal;
}

label {
  font-weight: 600;
  font-size: 14px;
  margin-top: 12px;
}

.text-grey {
  color: #5d6575;
}

.error-text {
  font-size: 12px;
}

.border-error {
  border: 1px solid red;
}

.finance-field-container {
  position: relative;
}
.finance-field-overlay {
  top: 0;
  left: 0;
  position: absolute;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0);
  transition: all 200ms;
  display: flex;
  justify-content: center;
  align-items: center;
}

.finance-field-overlay img {
  width: 100px;
  height: 100px;
  transition: all 200ms;
  opacity: 0;
}
.finance-field-container:hover .finance-field-overlay {
  background-color: rgba(0, 0, 0, 0.5);
}

.finance-field-container:hover .finance-field-overlay img {
  opacity: 1;
}

.e-multiselect.e-input-group .e-multi-select-wrapper {
  background-color: red;
}

/* Chrome, Safari, Edge, Opera */
.input_number input::-webkit-outer-spin-button,
.input_number input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

::-webkit-datetime-edit-year-field:not([aria-valuenow]),
::-webkit-datetime-edit-month-field:not([aria-valuenow]),
::-webkit-datetime-edit-day-field:not([aria-valuenow]) {
  color: transparent;
}
.finance_tag_grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px;
}

.check-box-text {
  color: #2e3646;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px; /* 125% */
  letter-spacing: -0.016px;
}

.most-overdue-title {
  color: #000;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 22px; /* 157.143% */
  letter-spacing: -0.014px;
}

.most-overdue-text {
  color: #2e3646;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 22px; /* 157.143% */
  letter-spacing: -0.014px;
}

.most-overdue-orange {
  color: #ff5252;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 22px; /* 157.143% */
  letter-spacing: -0.014px;
}

@media (max-width: 767px) {
  .nav-side-menu {
    position: relative;
    width: 100%;
    margin-bottom: 10px;
  }
  .nav-side-menu .toggle-btn {
    display: block;
    cursor: pointer;
    position: absolute;
    right: 10px;
    top: 10px;
    z-index: 10 !important;
    padding: 3px;
    background-color: #ffffff;
    color: #000;
    width: 40px;
    text-align: center;
  }
  .brand {
    text-align: left !important;
    font-size: 22px;
    padding-left: 20px;
    line-height: 50px !important;
  }
}
@media (min-width: 767px) {
  .nav-side-menu .menu-list .menu-content {
    display: block;
  }
}
@media (max-width: 573px) {
  .mobile-div {
    padding: 2px 0px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/RentAdjustment/CustomComponent/PaymentPreview/OrderTagForm.vue